import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthModal from "../User/Auth/AuthModal";

const ProtectedRoute = ({ children, jwt, role }) => {
    const [openAuthModal, setOpenAuthModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!jwt || !role) {
            setOpenAuthModal(true);
        }
    }, [jwt, role]);

    const handleCloseAuthModal = () => {
        setOpenAuthModal(false);
        // अगर अभी भी jwt नहीं बना (मतलब user login नहीं किया)
        if (!jwt || !role) {
            navigate("/", { replace: true });
        }
    };

    return (
        <>
            {jwt && role ? children : null}

            <AuthModal
                handleClose={handleCloseAuthModal}
                open={openAuthModal}
            />
        </>
    );
};

export default ProtectedRoute;
